import { getContext, storeToken, reset } from './service';
import { pairDevice, updateDeviceToken } from '../../components/notifications/nike-notification-server-api';
import { getNotificationLogger } from './log';
import buildNotification from './buildNotification';

const log = getNotificationLogger('notifications');

/**
 * Preparuje zariadenie
 */
export function rePairDevice() {
    log('(re)pair');
    pairDevice(getContext().token).catch(console.warn);
    reset();
}

/**
 * zaregistruje token, alebo ho updatne, alebo neurobi nic
 */
export async function syncToken(newToken) {
    log('syncToken', newToken);
    const { token } = getContext();

    if (!newToken) {
        return;
    }

    if (token) {
        if (newToken === token) {
            // s tokenom nepotrebujeme nic robit
            return;
        } else {
            // uzivatel ma token, a firebase token a user token su ROZDIELNE => update token
            storeToken(newToken);
            await updateToken(token, newToken);
        }
    } else {
        // user nema vobec ZIADNY token => register
        storeToken(newToken);
        await pairDevice(newToken).catch(e => {
            log('Cannot register token, well .. but what now?', e);
        });
    }
}

/**
 *  update token na servery ak dojde k chybe vykoname offline-ovu odregistraciu a verime, ze dalsi sync(...) prebehne spravne
 */
async function updateToken(deviceId, newDeviceId) {
    log('updateToken');
    try {
        await updateDeviceToken(deviceId, newDeviceId);
    } catch (e) {
        reset();
        log('Cannot update token, unknown error', e);
    }
}

export async function handleMessage(payload) {
    log('handleMessage');
    // dostal som spravu, vytvor notifikaciu
    const { title, options } = buildNotification(payload.data);
    const registration = await navigator.serviceWorker.ready;
    await registration.showNotification(title, options);
}
